import React, { useRef, useEffect } from "react";
import { Animated } from "react-native";

import { Container, StepProgress, FillOverlay, Percentage } from "./styled";

export const ProgressBar = ({ progress = 0 }) => {
  const animation = useRef(new Animated.Value(0));

  useEffect(() => {
    Animated.timing(animation.current, {
      toValue: progress,
      duration: 500,
    }).start();
  }, [progress]);

  const width = animation.current.interpolate({
    inputRange: [0, 100],
    outputRange: ["0%", "100%"],
    extrapolate: "clamp",
  });

  return (
    <Container>
      <StepProgress>
        <FillOverlay style={{ width }} />
        <Percentage>{progress}%</Percentage>
      </StepProgress>
    </Container>
  );
};
